module.exports = __webpack_public_path__ + "files/629a8cd027416b1d817f634f8f8f7485.png";